const DEFAULT_FILTERS = {
  leaveType: "all",
  status: "all",
  dateRange: { from: undefined, to: undefined },
};

export function areEmployeeFiltersEqual(a, b) {
  return (
    a.leaveType === b.leaveType &&
    a.status === b.status &&
    a.dateRange?.from?.getTime?.() === b.dateRange?.from?.getTime?.() &&
    a.dateRange?.to?.getTime?.() === b.dateRange?.to?.getTime?.()
  );
}

export function cloneEmployeeLeaveFilters(filters) {
  return {
    leaveType: filters.leaveType,
    status: filters.status,
    dateRange: {
      from: filters.dateRange?.from,
      to: filters.dateRange?.to,
    },
  };
}

export function countEmployeeActiveFilters(filters = DEFAULT_FILTERS) {
  let count = 0;
  if (filters.leaveType && filters.leaveType !== "all") count += 1;
  if (filters.status && filters.status !== "all") count += 1;
  if (filters.dateRange?.from || filters.dateRange?.to) count += 1;
  return count;
}

export function getDefaultEmployeeLeaveFilters() {
  return cloneEmployeeLeaveFilters(DEFAULT_FILTERS);
}

export { DEFAULT_FILTERS as DEFAULT_EMPLOYEE_LEAVE_FILTERS };
